



export default class SchemaManager
{

     static isMinSupportedSchemaVersion(appVersion, minAppSchemaVersion)
     {
        var appVerPieces = appVersion.split(".");
        var minAppSchemaVerPieces = minAppSchemaVersion.split(".");

        for (var i=0; i<3; i++)
        {
            let appPiece = parseInt(appVerPieces[i]);
            let schemaPiece = parseInt(minAppSchemaVerPieces[i]);
            if (appPiece>schemaPiece) return true;
            if (appPiece<schemaPiece) return false;
        }
        return true;
     }



}